import React from 'react';
import { createRoot } from 'react-dom/client';

// Μία και μόνη πηγή στυλ: Tailwind 4 και HeroUI.
//
// Το Bootstrap, το style.css των 8.449 γραμμών και το theme.css αφαιρέθηκαν. Δεν
// ήταν θέμα τάξης: το Reboot του Bootstrap ορίζει `button { border-radius: 0 }`
// χωρίς layer, και στο Tailwind 4 το ακατηγοριοποίητο CSS υπερισχύει του
// layered, οπότε ακύρωνε σιωπηλά το στρογγύλεμα κάθε κουμπιού του HeroUI.
import "./index.css";

import App from './App';

createRoot(document.getElementById('root')).render(<App />);
